import { Button, Modal, Typography } from "antd";
import { Download, FileText } from "lucide-react";
import React from "react";
import { TFile } from "~/types";

const { Text } = Typography;

interface DocumentPreviewModalProps {
  visible: boolean;
  document: TFile | null;
  onClose: () => void;
  onDownload: (doc: TFile) => void;
}

export const DocumentPreviewModal: React.FC<DocumentPreviewModalProps> = ({
  visible,
  document,
  onClose,
  onDownload,
}) => {
  return (
    <Modal
      title="Document Preview"
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
        <Button
          key="download"
          type="primary"
          icon={<Download size={16} />}
          onClick={() => document && onDownload(document)}
        >
          Download
        </Button>,
      ]}
      width={800}
    >
      {document && document.filePath ? (
        document.filePath ? (
          document.filePath.toLowerCase().endsWith(".pdf") ? (
            <iframe
              src={`${document.filePath}#toolbar=0`}
              className="w-full h-full"
              title={document.title}
            />
          ) : (
            <img
              src={document.filePath}
              alt={document.title}
              className="max-w-full max-h-full object-contain"
            />
          )
        ) : (
          <div className="text-center text-gray-400">
            <FileText size={48} className="mx-auto mb-2" />
            <p>Unable to preview this document</p>
          </div>
        )
      ) : (
        <div className="text-center p-8">
          <FileText size={48} className="mx-auto mb-4 text-gray-300" />
          <Text>No preview available</Text>
        </div>
      )}
    </Modal>
  );
};
